import Rox from 'rox-browser';

export const FlagsShipmentSeamless = {
  shipment_seamless_enable: new Rox.Flag(false),
};

export function initFlagsShipmentSeamless() {
  // register flags with namespaces for better grouping
  Rox.register("featureShipmentSeamless", FlagsShipmentSeamless);
}
